__turbopack_context__.v({
  "className": "pixelify_sans_b60f1858-module__NykWvG__className",
  "variable": "pixelify_sans_b60f1858-module__NykWvG__variable",
});
